import React from 'react';
import styles from './Pin.module.scss'


interface IPin {
  total: number | null
  color?: string
  width?: number
  height?: number
}

const Pin: React.FC<IPin> = ({ total, color = '#54e034', width = 30, height = 30 }) => {

  return (
    <div
      className={styles.markerWrapperClosed}
      style={{
        width: width,
        height: height,
        backgroundColor: color
      }}
    >
      <div
        className={styles.pinpoint}
        style={{
          backgroundColor: color,
          width: width / 2.5,
          height: height / 2.5
        }} />
      <div
        className={styles.content}
        style={{
          color: color,
          width: width / 2,
          height: height / 2
        }}
      ><p style={{ textAlign: 'center', fontSize: `${width / 2}px` }}>{`${total ? total : ''}`}</p></div>
    </div>
  );
}

export default Pin;
